"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = exports.ContextDataEvent = void 0;
const Name = exports.Name = 'context-data';
const ContextDataEvent = exports.ContextDataEvent = Name;
//# sourceMappingURL=index.js.map